import Image from 'next/legacy/image';
import FallbackImage from '@/images/partners/partners-fallback.webp';
import PhoneLink from '@/components/Button/PhoneLink';
import RollingLeadForm from '@/components/LeadForm/RollingLeadForm';
import TopFixedBanner from '../Banner/TopFixedBanner';
import EnergyPalLogo from '../../public/brand/EnergyPal-Logo-FullName-white.png';
import { StaticImageData } from 'next/image';

const BANNER_TEXT_DEFAULT = '$500 Gift card with EnergyPal';

type LandingPageProps = {
  cid: string;
  name: string;
  banner?: string;
  phone?: string;
  phoneDisplay?: string;
  logo?: StaticImageData;
  logoWidth?: string;
  image?: StaticImageData;
  containerClassName?: string;
  format?: 'image' | 'gradient';
};
// bg-gradient-to-r from-cyan-500 to-blue-500
export default function LandingPageV1({
  cid,
  name,
  logo,
  logoWidth,
  phone,
  phoneDisplay,
  image,
  format = 'image',
  containerClassName = 'text-white md:text-gray-900',
  banner = BANNER_TEXT_DEFAULT,
}: LandingPageProps) {
  return (
    <>
      {banner && <TopFixedBanner>{banner}</TopFixedBanner>}
      <div
        className={`grid grid-cols-1 ${
          format === 'image' ? 'md:grid-cols-2' : 'md:grid-cols-3'
        } min-h-[40rem] ${containerClassName}`}
      >
        <div className="absolute grid w-full grid-cols-1 p-4 z-90 sm:grid-cols-2">
          <div
            className={`grid self-center content-center z-30 hidden md:block relative h-full ${
              logo ? `${logoWidth ? logoWidth : 'w-24'}` : 'w-[10rem]'
            }`}
          >
            <Image
              src={logo ? logo : EnergyPalLogo}
              alt={`${name} + EnergyPal`}
            />
          </div>
          <div className="z-30 ">
            <p className="text-center sm:text-right">
              <PhoneLink
                className="text-2xl"
                phone={phone}
                phoneDisplay={phoneDisplay}
              />
            </p>
          </div>
        </div>

        <div
          className={`relative z-10 col-start-1 col-end-2 row-start-1 row-end-2 ${
            format === 'image' ? 'bg-black ' : 'hidden md:block md:col-end-3'
          }`}
        >
          <Image
            priority
            objectPosition={
              format === 'image' ? 'center center' : 'left bottom'
            }
            objectFit={format === 'image' ? 'cover' : 'contain'}
            layout="fill"
            src={image || FallbackImage}
            alt={`${name} + EnergyPal`}
            className="absolute inset-0 opacity-50 md:opacity-100"
          />
        </div>
        <div
          className={`z-20 col-start-1 col-end-1 row-start-1 row-end-1 bg-transparent md:col-start-2 md:col-end-2 ${
            format === 'image' ? 'md:bg-gray-200' : 'md:col-end-4'
          }`}
        >
          <div className="grid h-full max-w-4xl px-6 pt-16 pb-24 mx-auto sm:py-24 sm:px-6 md:place-content-center">
            <h1 className="text-3xl font-bold text-center ">
              Get Personalized Home Solar Quotes
            </h1>

            <div className="bg-white rounded-[2rem] md:max-w-2xl md:px-9 py-8 mt-8 text-gray-900">
              <RollingLeadForm cid={cid} />
            </div>
            <h2 className="mt-6 text-2xl font-bold text-center ">
              Powered by <span className="text-primary-500">Energy</span>
              <span className="text-secondary-500">Pal</span>
            </h2>
          </div>
        </div>
      </div>
    </>
  );
}
